export class ResponseParser {
  public static extractJsonFromResponse(content: string): string {
    const jsonMatch = content.match(/```(?:json)?\s*([\s\S]*?)\s*```/);
    if (jsonMatch) {
      return jsonMatch[1].trim();
    }
    return content.trim();
  }
}
